// Helpers
import useTranslate from "hooks/useTranslate";
import { setProfileClass } from "../../../helpers/class";

// Hooks

import "./styles.sass";

type ProfileHeaderProps = {
  title: string;
  mobileTitle?: string;
  account?: boolean;
};

const ProfileHeader = ({ title, mobileTitle, account }: ProfileHeaderProps) => {
  const t = useTranslate();

  return (
    <div className={setProfileClass("ProfileHeader", "", "account", account)}>
      <span
        className={setProfileClass(
          "ProfileHeader__title",
          "",
          "account",
          account,
        )}
      >
        {t(mobileTitle || title)}
      </span>
    </div>
  );
};

export default ProfileHeader;
